/**
 * R24 · Barrierefreiheit: deutsche Namen fuer Symbol-Steuerelemente
 *
 * Ausgelagert aus snippets/r24-a11y-polish.liquid (perf/pdp-weight, 23.09.2026): vorher inline und
 * parserblockierend in jeder Seite, jetzt gecacht und `defer` (laeuft nach dem
 * Parsen, vor DOMContentLoaded). Kein Liquid in dieser Datei.
 */
(function () {
  'use strict';
  // Icon-Steuerelemente → deutsches Label anhand robuster Kalles-Selektoren.
  var MAP = [
    ['.t4s-site-nav__cart > a, a[href$="/cart"], [data-cart-drawer-open]', 'Warenkorb'],
    ['.t4s-site-nav__search a, [data-toggle-search], .t4s-search-icon', 'Suche öffnen'],
    ['.t4s-site-nav__heart a, a[data-link-wishlist], a[href*="wishlist"]', 'Merkliste'],
    ['a[href*="/account"], .t4s-site-nav__account a', 'Konto'],
    ['.t4s-push-menu-btn, [data-toggle-menu], .t4s-menu-icon', 'Menü'],
    ['[data-close], .t4s-close, .btn-close-drawer, [aria-label="close"]', 'Schließen'],
    ['a[data-link-compare], a[href*="compare"]', 'Vergleichen']
  ];
  var SOCIAL = { 'facebook': 'Facebook', 'instagram': 'Instagram', 'youtube': 'YouTube',
    'tiktok': 'TikTok', 'pinterest': 'Pinterest', 'twitter': 'Twitter', 'x.com': 'X',
    'linkedin': 'LinkedIn', 'whatsapp': 'WhatsApp' };

  function hasText(el) {
    // Sichtbarer Text vorhanden? (dann braucht es kein Label)
    return (el.textContent || '').replace(/\s+/g, '') .length > 1;
  }
  function labelled(el) {
    return el.getAttribute('aria-label') || el.getAttribute('title') ||
      el.getAttribute('aria-labelledby');
  }
  function setLabel(el, txt) {
    if (!el || labelled(el) || hasText(el)) return;
    el.setAttribute('aria-label', txt);
  }

  function run(root) {
    root = root || document;
    // 1) bekannte Icon-Steuerelemente
    MAP.forEach(function (pair) {
      try {
        root.querySelectorAll(pair[0]).forEach(function (el) { setLabel(el, pair[1]); });
      } catch (e) { console.warn('[R24 a11y-Politur]', e && e.message); }
    });
    // 2) Social-Links (aus Domain ableiten)
    try {
      root.querySelectorAll('a[href^="http"]').forEach(function (a) {
        if (labelled(a) || hasText(a)) return;
        var h = (a.getAttribute('href') || '').toLowerCase();
        for (var key in SOCIAL) { if (h.indexOf(key) !== -1) { a.setAttribute('aria-label', SOCIAL[key]); break; } }
      });
    } catch (e) { console.warn('[R24 a11y-Politur]', e && e.message); }
    // 3) Bilder ohne alt-Attribut → sinnvolles alt (sonst leer = dekorativ)
    try {
      root.querySelectorAll('img:not([alt])').forEach(function (img) {
        var t = '';
        var card = img.closest('a[href], .t4s-product, .r24-pd-card, figure');
        if (card) {
          var titleEl = card.querySelector('.t4s-product-title, .t, .name, [class*="title"]');
          t = (titleEl && titleEl.textContent || card.getAttribute('title') ||
               card.getAttribute('aria-label') || '').trim();
        }
        img.setAttribute('alt', t.replace(/\s*\(Kopie\)/gi, '').slice(0, 120));
      });
    } catch (e) { console.warn('[R24 a11y-Politur]', e && e.message); }
  }

  function boot() {
    run(document);
    try {
      /* Gebuendelt: ein Durchlauf je Bild statt je Mutationsschub. Karussells,
         Pager (36 Karten) und Drawer loesen mehrere Schuebe kurz hintereinander
         aus — jeder lief vorher ueber das ganze Dokument (Audit A16). */
      var queued = false;
      var mo = new MutationObserver(function (muts) {
        if (queued) return;
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) {
            queued = true;
            (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(document); });
            break;
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { console.warn('[R24 a11y-Politur]', e && e.message); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
